import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { licenseGapsQuery, licenseTableQuery, type LicenseGap } from '../api/inventoree'
import { Content } from '../ui/Shell'
import { DataTable, useTableState } from '../ui/DataTable'
import { licenseColumns } from './columns'
import { LicenseExpand } from './LicenseExpand'

/**
 * Inventoree Software Licenses - software_licenses/index.php +
 * SoftwareLicensesModel / licenseGaps din inventoree.js.
 * Expandul randului: getSoftwareLicensesTabs + cele trei file.
 */

function Gaps({ gaps }: { gaps: LicenseGap[] }) {
  if (gaps.length === 0) {
    return <div className="text-muted" style={{ padding: 12 }}>No license gaps.</div>
  }
  const max = Math.max(...gaps.map((g) => Math.abs(Number(g.value) || 0)), 1)
  return (
    <div className="license-gaps-bars" style={{ display: 'flex', alignItems: 'flex-end', height: 170, gap: 8, padding: '8px 12px' }}>
      {gaps.map((g) => {
        const value = Number(g.value) || 0
        const h = Math.max(8, Math.round((Math.abs(value) / max) * 140))
        return (
          <div key={g.name} style={{ flex: '1 1 0', minWidth: 36, textAlign: 'center' }}>
            <div style={{ height: 140, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
              <div title={`${g.name}: ${value}`} style={{ width: '70%', height: h, background: '#84B761' }}></div>
            </div>
            <div className="font-11" style={{ marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {g.name}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export function SoftwareLicensesPage() {
  const [state, setState] = useTableState('softwareLicenses', { start: 0, length: 25, order: { column: 1, dir: 'asc' }, search: '' })
  const table = useQuery({
    ...licenseTableQuery({
      draw: 1,
      start: state.start,
      length: state.length,
      orderColumn: state.order.column,
      orderDir: state.order.dir,
      search: state.search,
    }),
    placeholderData: keepPreviousData,
  })
  const gaps = useQuery(licenseGapsQuery)
  const columns = licenseColumns()

  return (
    <Content>
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-warning">
            <div className="panel-heading">License Gaps</div>
            <div className="panel-body" style={{ height: 180, padding: 5, overflow: 'hidden', textAlign: 'left' }} id="license-gaps">
              {gaps.isError ? (
                <div className="text-muted">The license gaps could not be read just now.</div>
              ) : !gaps.data ? null : (
                <Gaps gaps={gaps.data} />
              )}
            </div>
          </div>
        </div>
      </div>
      <DataTable
        id="softwareLicenses"
        columnTools
        columns={columns}
        rows={(table.data?.data ?? []) as Record<string, unknown>[]}
        total={table.data?.recordsTotal ?? 0}
        fetching={table.isFetching}
        error={table.isError ? (table.error as Error).message : null}
        onRetry={() => void table.refetch()}
        state={state}
        onState={setState}
        rowId={(r) => String(r.DT_RowId ?? r.ID)}
        details={(row) => <LicenseExpand applicationId={Number(row.ID)} />}
      />
    </Content>
  )
}
